import { render, staticRenderFns } from "./EscolherEscola.vue?vue&type=template&id=1c6dd95c&scoped=true&"
import script from "./EscolherEscola.vue?vue&type=script&lang=js&"
export * from "./EscolherEscola.vue?vue&type=script&lang=js&"
import style0 from "./EscolherEscola.vue?vue&type=style&index=0&id=1c6dd95c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6dd95c",
  null
  
)

export default component.exports